import { ca } from '@cian/analytics';

export const trackNavigationItemClick = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'tapBar',
    action: 'click',
    label,
  });
};
